import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import '../styles/modelListPage.css';
import '../styles/modelDetails.css';
import '../styles/common.css';
//imports for componets exposed by the app with lazy loading to avoid eager fetching of all the components
const NotFound = React.lazy(() => import('../pages/NotFound'));
const ModelsListPage = React.lazy(() => import('../pages/Models/ModelsListPage'));
const ModelDetailsPage = React.lazy(() => import('../pages/Models/ModelsDetailsPage'));
const VoiceAssistantRedirect = React.lazy(() => import('../components/Redirect/VoiceAssistant'));
const About = React.lazy(() => import('../pages/About'));
import Header from '../components/Header';
import Spinner from '../components/Spinner';
import { preloadModelsData } from '../api/modelsApi';
import Footer from '../components/Footer';
import { appConfig } from '../config/appConfig';
/*app route componet for rounting between pages*/
const AppRoute = () => {
    const [loadingModels, setLoadingModels] = React.useState(true);
    const location = useLocation();
    useEffect(() => {
        (async () => {
            try {
                await preloadModelsData();
            }
            catch (error) {
                console.error('Error preloading models data:', error);
            }
            finally {
                setLoadingModels(false);
            }
        })();
    }, []);
    useEffect(() => {
        if (window.gtag) {
            window.gtag('config', 'G-SLW8GS4TBC', { page_path: location.pathname });
        }
    }, [location]);
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), loadingModels ? (_jsx(Spinner, { styles: { height: '100vh', width: '100%' } })) : (_jsxs(Suspense, { fallback: _jsx(Spinner, { styles: { height: '100vh', width: '100%' } }), children: [_jsx("div", { className: "mt-vh-15" }), _jsx("div", { style: { minHeight: '85vh' }, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(ModelsListPage, {}) }), _jsx(Route, { path: "/models/:name", element: _jsx(ModelDetailsPage, {}) }), _jsx(Route, { path: "/solutions/voice-assistant", element: _jsx(VoiceAssistantRedirect, {}) }), _jsx(Route, { path: "/about", element: _jsx(About, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }) }), _jsx(Footer, { links: appConfig === null || appConfig === void 0 ? void 0 : appConfig.footer_links })] }))] }));
};
export default AppRoute;
